"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeValidationMap = void 0;
exports.validateType = validateType;
const reEMAIL = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
const rePHONE = /^\d{10}$/;
// URL regex does not support FTP, IP addresses, port numbers
const reURL = /^(?:https?:\/\/)?(?:(?![-_])[-\w\u00a1-\uffff]{0,63}[^-_]\.)+[-\w\u00a1-\uffff]+(?:\/[^\s]*)?$/i;
exports.typeValidationMap = {
    email: (value) => reEMAIL.test(value),
    tel: (value) => rePHONE.test(value),
    url: (value) => reURL.test(value),
};
function validateType(type, value) {
    const validator = exports.typeValidationMap[type];
    if (!validator) {
        return undefined;
    }
    return value ? validator(value) : true;
}
//# sourceMappingURL=type-validation.js.map